module.exports = __webpack_public_path__ + "images/85d2fdb7ef5a65d2b0268150bd41b319.png";